<div [class]="('normalText rateAvailabilityReport_' + (auditResults?'shortGrid1':'tallGrid1'))"
  id="rateAvailabilityReport_grid1">
  <div class="gridHeader">
    <span class="gridTitle">Interactive Report Viewer - </span>
    <span class="gridHeaderListCount">{{this.gridView ? this.gridView.total : '0'}} Properties Shown</span>
    <a class="downloadFullReportLink" (click)="GetFullReportToExcel($event)">
      <span class="cvt-icon-download" title="Download Full Report To Excel"></span>
      <span class="downloadFullReportLinkText">Download To Excel</span>
    </a>
  </div>
  <app-alert></app-alert>
  <div class="gridDropDownRow">
    <span class="gridDropDownRowText">Displayed GDS</span>
    <kendo-dropdownlist #list *ngIf="gdsCodeList && gdsCodeList.length>0"
      [data]="gdsCodeList"
      [value]="selectedGDSCode"
      [valuePrimitive]="false"
      [textField]="'text'"
      [valueField]="'value'"
      (selectionChange)="gdsSelect($event)">
      <ng-template kendoDropDownListValueTemplate let-dataItem>
        <span>{{dataItem.text}}</span>
      </ng-template>
      <ng-template kendoDropDownListItemTemplate let-dataItem>{{dataItem.text}}</ng-template>
    </kendo-dropdownlist>
    <div class="legendContainingDiv">
      <div class="darkGreenFillBox fillBox"></div><span class="darkGreenFillBoxLabel fillBoxLabel">Loaded</span>
      <div class="darkYellowFillBox fillBox"></div><span class="darkYellowFillBoxLabel fillBoxLabel">Loaded Higher</span>
      <div class="lightBlueFillBox fillBox"></div><span class="lightBlueFillBoxLabel fillBoxLabel">Loaded Lower</span>
    </div>
  </div>
  <kendo-grid
    [data]="gridView"
    class="normalText"
    [sort]="state.sort"
    [sortable]="true"
    [pageable]="false"
    [scrollable]="'scrollable'"
    [kendoGridSelectBy]="'Name'"
    (dataStateChange)="dataStateChange($event)"
    (click)="gridClicked($event)">
    <kendo-grid-column field="Name" title="Hotel Name" [width]="190">
        <ng-template kendoGridHeaderTemplate  let-column >
            <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
        </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-column>
        <div class="reportCellLeft">{{dataItem.Name}}</div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="ChainCode" title="Chain Code" [width]="130">
        <ng-template kendoGridHeaderTemplate  let-column >
            <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
        </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="reportCellLeft">{{dataItem.ChainCode}}</div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="PropCode" title="Property Code" [width]="140">
        <ng-template kendoGridHeaderTemplate  let-column >
            <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
        </ng-template>
      <ng-template kendoGridHeaderTemplate let-column>
        {{column.title}}
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="reportCellLeft">{{dataItem.PropCode}}</div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="RateAccessCode" title="Rate Access Code" [width]="160">
        <ng-template kendoGridHeaderTemplate  let-column >
            <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
        </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="reportCellLeft">{{dataItem.RateAccessCode}}</div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="Season1ExpectedPrice" title="Season 1" [width]="150">
        <ng-template kendoGridHeaderTemplate  let-column >
            <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
        </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="reportCellRight">
          <div><span [innerText]='dataItem.Season1ExpectedPrice | price:  dataItem.Season1Dynamic : dataItem.Season1Ceiling '>{{dataItem.Season4ExpectedPrice}}</span></div><div class="secondLine">{{dataItem.Season1StartDate}} - {{dataItem.Season1EndDate}}</div>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="Season2ExpectedPrice" title="Season 2" [width]="150">
        <ng-template kendoGridHeaderTemplate  let-column >
            <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
        </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="reportCellRight">
          <div><span [innerText]='dataItem.Season2ExpectedPrice | price:  dataItem.Season2Dynamic : dataItem.Season2Ceiling '>{{dataItem.Season4ExpectedPrice}}</span></div><div class="secondLine">{{dataItem.Season2StartDate}} - {{dataItem.Season2EndDate}}</div>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="Season3ExpectedPrice" title="Season 3" [width]="150">
        <ng-template kendoGridHeaderTemplate  let-column >
            <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
        </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="reportCellRight">
          <div><span [innerText]='dataItem.Season3ExpectedPrice | price:  dataItem.Season3Dynamic : dataItem.Season3Ceiling '>{{dataItem.Season4ExpectedPrice}}</span></div><div class="secondLine">{{dataItem.Season3StartDate}} - {{dataItem.Season3EndDate}}</div>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="Season4ExpectedPrice" title="Season 4" [width]="150">
        <ng-template kendoGridHeaderTemplate  let-column >
            <span >{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
        </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="reportCellRight">
          <div><span [innerText]='dataItem.Season4ExpectedPrice | price:  dataItem.Season4Dynamic : dataItem.Season4Ceiling '>{{dataItem.Season4ExpectedPrice}}</span></div><div class="secondLine">{{dataItem.Season4StartDate}} - {{dataItem.Season4EndDate}}</div>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column *ngFor="let theDate of selectedDates; let i = index"  [width]="100">
      <ng-template kendoGridHeaderTemplate class="text-medium" let-column let-columnIndex="columnIndex">
        {{theDate | date:'shortDate'}}
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div
        (click)="dateSelect($event, dataItem, i, theDate)"
        [class]="('doNotShowErrorMessage reportCellRight ' + (dataItem.DateInf[i].Status==1?'darkGreenLink':(dataItem.DateInf[i].Status==2?'redLink':(dataItem.DateInf[i].Status==3?'darkYellowLink':(dataItem.DateInf[i].Status==4?'lightBlueLink':'violetLink')))))"
        >
            <div>{{dataItem.DateInf[i].DisplayPrice}}</div>
            <div class="secondLine">Season {{dataItem.DateInf[i].Season}}</div>
        </div>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>

<div id="rateAvailabilityReport_grid2" *ngIf="auditResults">
  <div class="gridHeader" *ngIf="auditResults">
    <span class="gridTitle">Full GDS Result Set - </span>
    <span class="gridHeaderListCount">Rates Returned - {{auditResults.total}} BAR Rates : {{numBarRates}} Negotiated Rate : - {{numNegRates}} {{gridView2TitleHotelName}} [{{gridView2TitleDate | date:'shortDate'}}]</span>
  </div>
  <kendo-grid
    [data]="auditResults"
    [scrollable]="'scrollable'"
    [sort]="stateResultDataset.sort"
    [sortable]="true"
    [pageable]="false"
    (dataStateChange)="dataStateChangeDS($event)">
    <kendo-grid-column field="NegotiatedRate" title="NEG" [width]="55">
        <ng-template kendoGridHeaderTemplate  let-column >
            <span >{{column.title}}</span>&emsp;<img *ngIf="this.sortedResultDataset !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
        </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem.NegotiatedRate" class="cvt-icon-check grid-status-icons"></span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="BARRate" title="BAR" [width]="55">
        <ng-template kendoGridHeaderTemplate  let-column >
            <span >{{column.title}}</span>&emsp;<img *ngIf="this.sortedResultDataset !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
        </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem.BARRate" class="cvt-icon-check grid-status-icons"></span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="SelecteNegRate" title="S-NEG" [width]="70">
        <ng-template kendoGridHeaderTemplate  let-column >
            <span >{{column.title}}</span>&emsp;<img *ngIf="this.sortedResultDataset !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
        </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem.SelecteNegRate" class="cvt-icon-check grid-status-icons"></span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="SelectedBARRate" title="S-BAR" [width]="70">
        <ng-template kendoGridHeaderTemplate  let-column >
            <span >{{column.title}}</span>&emsp;<img *ngIf="this.sortedResultDataset !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
        </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem.SelectedBARRate" class="cvt-icon-check grid-status-icons"></span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="RoomCode" title="Booking Code" [width]="150">
        <ng-template kendoGridHeaderTemplate  let-column >
            <span >{{column.title}}</span>&emsp;<img *ngIf="this.sortedResultDataset !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="PlanType" title="Booking Code Description">
        <ng-template kendoGridHeaderTemplate  let-column >
            <span >{{column.title}}</span>&emsp;<img *ngIf="this.sortedResultDataset !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="Rate" title="Rate" [[width]]="100">
        <ng-template kendoGridHeaderTemplate  let-column >
            <span >{{column.title}}</span>&emsp;<img *ngIf="this.sortedResultDataset !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
        </ng-template>
    </kendo-grid-column>

  </kendo-grid>
</div>
